export default __webpack_public_path__ + "static/og-img-1.5M-conservation-international-3ccd2a2963c9b407038dc6a461db3959.png";